import './App.css';
import Messages from "./containers/Messages";


function App() {
  return (
    <div className="App">
      <Messages/> 
    </div>
  );
}

export default App;
